import React from 'react';
import TableListRectorat from "./TableListRectorat"

const DashboardRectorat = () => {
  return (
    <div>
      <TableListRectorat/>
    </div>
  )
}

export default DashboardRectorat